/*
 * @Author: liuxiaoyan
 * @Date: 2021-10-31 10:51:12
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2022-06-21 21:58:57
 * @Description: 测评中心路由
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
export default {
  routes: [
    {
      path: '/choosenExhibition',
      name: 'choosenExhibition',
      component: () => import('@/module/artExhibition/ChoosenExhibition'),
      meta: {
        title: '',
        keepAlive: true,
        logined: false
      }
    },
    {
      path: '/artExhibition',
      name: 'artExhibition',
      component: () => import('@/module/artExhibition/Exhibition'),
      meta: {
        title: '艺术展',
        keepAlive: false,
        logined: false
      }
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/ArtExhibition.js